
import img1 from '../images/layouts/team-01.png'
import img2 from '../images/layouts/team-02.png'
import img3 from '../images/layouts/team-03.png'
import img4 from '../images/layouts/team-04.png'
import img5 from '../images/layouts/team-05.png'
import img6 from '../images/layouts/team-06.png'
import img7 from '../images/layouts/team-07.png'
import img8 from '../images/layouts/team-08.png'

const dataTeam = [

    {
        id: 1,
        img: img1,
        name: 'Jane Cooper',
        position: 'Founder & CEO'
    },
    {
        id: 2,
        img: img2,
        name: 'Jenny Wilson',
        position: 'Designer'
    },

    {
        id: 3,
        img: img3,
        name: 'Ralph Edwards',
        position: 'Developer'
    },

    {
        id: 4,
        img: img4,
        name: 'Cody Fisher',
        position: '3D Artist'
    },

    {
        id: 5,
        img: img5,
        name: 'Jane Cooper',
        position: 'Founder & CEO'
    },
    {
        id: 6,
        img: img6,
        name: 'Jane Cooper',
        position: 'Founder & CEO'
    },
    {
        id: 7,
        img: img7,
        name: 'Jenny Wilson',
        position: 'Designer'
    },

    {
        id: 8,
        img: img8,
        name: 'Ralph Edwards',
        position: 'Developer'
    },

    {
        id: 9,
        img: img4,
        name: 'Cody Fisher',
        position: '3D Artist'
    },

    {
        id: 10,
        img: img1,
        name: 'Jane Cooper',
        position: 'Founder & CEO'
    },

    {
        id: 11,
        img: img2,
        name: 'Jenny Wilson',
        position: 'Designer'
    },

    {
        id: 12,
        img: img3,
        name: 'Ralph Edwards',
        position: 'Developer'
    },

    

]

export default dataTeam;